import { UncontrolledTooltip } from 'reactstrap';

const FieldInfo = ({
    id,
    children,
}) => {
    if (!id || !children) {
        return null;
    }

    return (
        <>
            <i
                className="ri-information-line align-middle ms-1 text-muted"
                id={id}
                style={{ cursor: 'pointer', fontSize: '15px' }}
            />
            <UncontrolledTooltip
                placement="top"
                target={id}
                trigger="hover"
                innerClassName="text-start"
                style={{ maxWidth: '320px' }}
            >
                {children}
            </UncontrolledTooltip>
        </>
    );
};

export default FieldInfo;
